/**
 * Created by fworld on 2019/7/11.
 */
import request from '@/util/request'

export function orderUnion(data) {
  return request({
    url: '/api/v1/delivery/order/union',
    method: 'get',
    params: data
  })
}


export function orderList(data) {
  return request({
    url: '/api/v1/delivery/order/list',
    method: 'get',
    params: data
  })
}

export function orderSurvey(data) {
  return request({
    url: '/api/v1/delivery/order/survey',
    method: 'get',
    params: data
  })
}

export function orderDrinkTop10(data) {
  return request({
    url: '/api/v1/delivery/order/drink/top10',
    method: 'get',
    params: data
  })
}

export function orderDeviceTop10(data) {
  return request({
    url: '/api/v1/delivery/order/device/top10',
    method: 'get',
    params: data
  })
}

export function orderlst24H(data) {
  return request({
    url: '/api/v1/delivery/order/drink/lst24Hour',
    method: 'get',
    params: data
  })
}

export function orderAnalyze(params) {
  return request({
    url: '/api/v1/delivery/order/analyze',
    method: 'get',
    params
  })
}

export function orderCompare(data) {
  return request({
    url: '/api/v1/delivery/order/compare',
    method: 'post',
    data
  })
}
